"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _index = require("../../../utils/styles/index");
/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */

/* ++++++++++ --------------- EXPORT : MENU : LINK : STYLES --------------- ++++++++++ */


var _default = {
  linkmenu: {
    position: 'relative',
    display: 'inline-flex',
    // menu items
    '& .menuitems': {
      width: 'max-content',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      position: 'absolute',
      top: (0, _index.replacePXinStringWithEM)('calc(100% + 15px)'),
      left: '50%',
      transition: 'all .05s ease-out 0s',
      '& .arrow': {
        alignSelf: 'center',
        width: '0',
        height: '0',
        boxSizing: 'border-box',
        marginBottom: (0, _index.pxToEm)(-10),
        border: (0, _index.replacePXinStringWithEM)("10px solid ".concat(_index.theme.color.light.light.swatch)),
        borderColor: "transparent transparent ".concat(_index.theme.color.light.light.swatch, " ").concat(_index.theme.color.light.light.swatch),
        transform: 'rotate(135deg)',
        boxShadow: (0, _index.replacePXinStringWithEM)("-1px 1px 1px 0 rgba(0, 0, 0, 0.1)")
      },
      '& .items': {
        background: _index.theme.color.light.light.swatch,
        borderRadius: (0, _index.pxToEm)(5),
        boxShadow: _index.theme.boxShadow.small
      }
    },
    // ----- states ----- //
    '&.active-true': {
      '& .menuitems': {
        opacity: '1',
        transform: 'translateX(-50%) scale(1)',
        zIndex: '2'
      }
    },
    '&.active-false': {
      '& .menuitems': {
        opacity: '0',
        transform: 'translateX(-50%) scale(0)',
        zIndex: '-1'
      }
    }
  }
};
exports.default = _default;